/**
 * Takes an array ['string', 'string'] and formats to "string, string"
 *
 * @param {array} stringArray
 */
export const createFormattedTitleFromArray = (stringArray, seperator = ", ", suffixCharsToRemove = -2) => {
  let title = "";
  if (!stringArray) {
    return title;
  }
  stringArray.map(item => {
    title = title.concat(`${item}${seperator}`);
  });
  return title.slice(0, suffixCharsToRemove);
};